'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventScoresByAdjudicatorAreLoading = exports.scoresAreLoading = exports.eventScoresByAdjudicator = exports.getScores = exports.getScore = exports.scoreByAdjudicatorUrl = exports.feisPrefixUrl = undefined;

var _immutable = require('immutable');

var feisPrefixUrl = exports.feisPrefixUrl = function feisPrefixUrl(fid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid;
};
var scoreByAdjudicatorUrl = exports.scoreByAdjudicatorUrl = function scoreByAdjudicatorUrl(fid, eid, aid, pid) {
  return IFEIS_API_URI + '/api/feiseanna/' + fid + '/events/' + eid + '/adjudicators/' + aid + '/persons/' + pid + '/scores';
};

var getScore = exports.getScore = function getScore(state, score_id) {
  return state.getIn(['scores', 'one', score_id]) || (0, _immutable.Map)();
};

var getScores = exports.getScores = function getScores(state, eid, pid) {
  return state.getIn(['scores', 'persons', pid, 'events', eid]) || (0, _immutable.List)();
};
var eventScoresByAdjudicator = exports.eventScoresByAdjudicator = function eventScoresByAdjudicator(state, eid, aid) {
  return state.getIn(['events', 'scores', eid, aid]) || (0, _immutable.Map)();
};

var scoresAreLoading = exports.scoresAreLoading = function scoresAreLoading(state, pid) {
  return state.getIn(['scores', 'persons', pid, 'loading']);
};
var eventScoresByAdjudicatorAreLoading = exports.eventScoresByAdjudicatorAreLoading = function eventScoresByAdjudicatorAreLoading(state, eid, aid) {
  return !state.getIn(['events', 'scores', eid, aid]) || state.getIn(['events', 'scores', eid, aid, 'loading']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scores/paths.js
// module id = 35
// module chunks = 0